import React, { Component } from 'react';
import moment from 'moment';

import './Header.scss';

class Header extends Component {
  render () {
    return (
      <div className='student-report-header'>
        <div className='student-report-header__logo'>
          <img src='/images/student-report/logo.png' alt='Paragon One Logo' />
        </div>
        <div className='student-report-header__title'>
          <div className='container'>
            <h1>Paragon One Report for {this.props['student-report-data'].user.first_name} {this.props['student-report-data'].user.last_name}</h1>
            {this.props['student-report-data'].summaries.length > 0 && (
              <p>Created on <span>{moment(this.props['student-report-data'].summaries[0].summary_date).format('MMM DD, YYYY')}</span></p>
            )}
          </div>
        </div>
        <div className='student-report-header__summary'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-7'>
                <h3>Your Skills Analysis</h3>
                {this.props['student-report-data'].summaries.length > 0 &&
                  <p>{this.props['student-report-data'].summaries[0].summary_text}</p>
                }
              </div>
              <div className='col-md-5'>
                <h3>Your Career Interests</h3>
                <ul>
                  {this.props['student-report-data'].top_industries.map((industry, index) =>
                    (<li key={industry.id}><span className='order-number'>{index + 1}</span> {industry.name}</li>)
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/Header/index.js